import React from "react"
import styled from "styled-components"
import logo from "../../../images/logo.svg"
import NavbarContent from "./navbarContent"
import NavbarItem from "./navbarItem"
import NavbarLink from "./navbarLink"
import { useStaticQuery, graphql } from "gatsby"

const NavbarWrapper = styled.div`
  background: linear-gradient(
    rgba(0, 0, 0, 1),
    rgba(0, 0, 0, 0.7),
    rgba(0, 0, 0, 0)
  );
  position: fixed;
  top: 0;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  > * {
    max-width: 90vw;
  }

  margin: 0 auto;
  padding: 2rem 1rem;

  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  @media screen and (max-width: 767px) {
    > :nth-child(1) {
      order: 1;
    }
    > :nth-child(2) {
      order: 3;
    }
    > :nth-child(3) {
      order: 2;
    }
    flex-wrap: wrap;
    overflow: scroll;
  }

  @media screen and (min-width: 768px) {
    > * {
      max-width: 960px;
      width: 960px;
      text-align: center;
    }
  }
`

const LinkToNike = styled.a`
  color: #fff;
  padding: 0;
  margin: 0;
  :hover {
    text-decoration: none;
    color: #dedede;
  }
`

const Navbar = () => {
  const navbarData = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          linkForNavbar {
            name
            link
          }
        }
      }
    }
  `)
  const { linkForNavbar } = navbarData.site.siteMetadata
  return (
    <NavbarWrapper>
      <div>
        <img src={logo} alt="Nike's Logo" />
      </div>
      <NavbarContent>
        {linkForNavbar.map((link, index) => {
          return (
            <NavbarItem key={index}>
              <NavbarLink href={link.link}>{link.name}</NavbarLink>
            </NavbarItem>
          )
        })}
        <NavbarItem>
          <NavbarLink></NavbarLink>
        </NavbarItem>
      </NavbarContent>
      <LinkToNike href="https://nike.com">nike.com</LinkToNike>
    </NavbarWrapper>
  )
}

export default Navbar
